import { PurchaseOrder } from '@domain/purchasing/models/PurchaseOrder';
import { PurchaseOrderDTO } from '../dto/PurchaseOrderDTO';
import { PurchaseOrderItemMapper } from './PurchaseOrderItemMapper';
import { CreatePurchaseOrderDTO } from '../dto/CreatePurchaseOrderDTO';
import { UpdatePurchaseOrderDTO } from '../dto/UpdatePurchaseDTO';
import { ShipmentMapper } from './ShipmentMapper';
import { SupplierMapper } from '@infrastructure/suppliers/mappers/SupplierMapper';

export class PurchaseOrderMapper {
  static toModel(dto: PurchaseOrderDTO): PurchaseOrder {
    return {
      id: dto.id,
      poNumber: dto.poNumber,
      createdAt: dto.createdAt ? new Date(dto.createdAt) : undefined,
      updatedAt: dto.updatedAt ? new Date(dto.updatedAt) : undefined,
      items: dto.items ? dto.items.map(item => PurchaseOrderItemMapper.toModel(item)) : [],
      orderDate: dto.orderDate ? new Date(dto.orderDate) : undefined,
      draft: dto.draft,
      supplierId: dto.supplier_id ?? dto.supplier?.id,
      supplier: dto.supplier ? SupplierMapper.toModelEmbedded(dto.supplier) : undefined,
    };
  }

  static toCreateDTO(model: PurchaseOrder): CreatePurchaseOrderDTO {
    return {
      poNumber: model.poNumber,
      items: model.items.map(item => PurchaseOrderItemMapper.toCreateDTO(item)),
      orderDate: model.orderDate?.toISOString(),
      supplierId: model.supplier?.id ?? model.supplierId,
      draft: model.draft
    };
  }

  static toUpdateDTO(model: PurchaseOrder): UpdatePurchaseOrderDTO {
    return {
      poNumber: model.poNumber,
      orderDate: model.orderDate?.toISOString(),
      supplierId: model.supplier?.id ?? model.supplierId,
      items: model.items?.map(item => ({
        productId: item.product.id,
        quantity: item.quantity,
        shipment: item.shipment ? ShipmentMapper.updateRequestToDTO(item.shipment) : undefined,
        status: item.status,
        eta: item.eta?.toISOString(),
        recommendedQuantity: item.recommendedQuantity,
      })),
      draft: model.draft
    };
  }
} 